import React, { Component } from 'react';


/////////////////////////////////////////////////////////
//// test component with GET
/////////////////////////////////////////////////////////


export class TESTComponent extends Component {

  constructor(props) {
    super(props);
    this.state = { arr: [], loading: true };
  }

  componentDidMount() {
    this.fetchSreenData();
  }

  static renderForecastsTable(arr) {
    return (
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Date</th>
            <th>Temp. (C)</th>
            <th>Temp. (F)</th>
            <th>Summary</th>
          </tr>
        </thead>
        <tbody>
          {arr.map(a =>
            <tr>
                  <td>{a.freighter}</td>
                  <td>{a.reference}</td>
                  <td>{a.commission}</td>
                  <td>{a.reference}</td>
                  <td>{a.stockplace}</td>
              </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    let contents = this.state.loading
        ? <p><em>Loading...</em></p>
        : TESTComponent.renderForecastsTable(this.state.arr);

    return (
      <div>
        <h1 id="tabelLabel" >Weather forecast</h1>
        <p>This component demonstrates fetching data from the server.</p>
        {contents}
      </div>
    );
  }

    async fetchSreenData() {
    const response = await fetch('screendata');
    const data = await response.json();
    this.setState({ arr: data.data, loading: false });
  }
}
